import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, User, ArrowUpCircle } from "react-feather";
import { FiUsers, FiEdit } from "react-icons/fi";
import { AuthContext } from "../../../../Auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecruiterProfile } from "../../../../redux/recruiter/recruiter_profile/actions";
import { AVATAR } from "../../../../Constant";
import point from "../../../../../src/assets/images/point.png";
import AxiosInstance from "../../../../services/AxiosInstance";

const UserHeader = () => {
  const dispatch = useDispatch();
  const { logout, totalPoints, user } = useContext(AuthContext);
  const history = useNavigate();
  const [profile, setProfile] = useState("");
  const [name, setName] = useState("Your Name");
  const [planName, setPlanName] = useState("");

  const recruiterProfileReducerData = useSelector(
    (state) => state.recruiterProfileReducer
  );
  const recruiterProfile = recruiterProfileReducerData.data;

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  useEffect(() => {
    // Fetch recruiter profile on component mount
    dispatch(fetchRecruiterProfile());
  }, [dispatch]);

  useEffect(() => {
    // Populate form data with fetched recruiter profile data
    if (recruiterProfile && recruiterProfileReducerData.isLoading !== true) {
      if (recruiterProfile.profile_image) {
        setProfile(recruiterProfile.profile_image);
      } else {
        setProfile(AVATAR);
      }

      setName(recruiterProfile.recruiter_full_name || "Your Name");

      if (
        recruiterProfile.plan_name ||
        recruiterProfile.current_plan ||
        recruiterProfile.plan
      ) {
        setPlanName(
          recruiterProfile.plan_name ||
          recruiterProfile.current_plan ||
          recruiterProfile.plan
        );
      }
    }
  }, [recruiterProfileReducerData, recruiterProfile]);

  useEffect(() => {
    // Fetch active plan info from API if not available in recruiterProfile
    const fetchPlanNameInfo = async () => {
      try {
        const response = await AxiosInstance().get("/api/usage-logs", {
          params: { page: 1, per_page: 1 },
        });

        if (response?.data?.status) {
          const activePlan =
            response?.data?.active_plan?.plan_name ||
            response?.data?.active_plan_name ||
            response?.data?.plan_name ||
            (response?.data?.data && response?.data?.data[0]?.plan_name);

          if (activePlan) {
            setPlanName(activePlan);
          } else if (response?.data?.has_active_plan === false) {
            setPlanName("No Active Plan");
          } else {
            setPlanName(
              response?.data?.data && response?.data?.data.length > 0
                ? "Active Plan"
                : "No Active Plan"
            );
          }
        }
      } catch (error) {
        console.log("Error fetching plan info for header:", error);
      }
    };

    fetchPlanNameInfo();
  }, []);

  const isRecruiter =
    !user?.type || user?.type?.toUpperCase() === "RECRUITER";

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <img
          width="35px"
          height="35px"
          className="b-r-10 m-0"
          src={profile ? profile : AVATAR}
          alt={profile ? "Profile image" : "Default avatar"}
        />

        <div className="profile-user-info">
          <span className="profile-user-name">
            {name}
          </span>

          {isRecruiter && planName && (
            <span className="profile-plan-name badge bg-light-primary text-primary">
              {planName}
            </span>
          )}
        </div>
      </div>
      <ul className="simple-list profile-dropdown onhover-show-div">
        <li
          className="d-flex"
          onClick={() =>
            UserMenuRedirect(`${process.env.PUBLIC_URL}/recruiter/referral`)
          }
        >
          <img
            width="28px"
            height="28px"
            className="b-r-10 m-0"
            src={point}
            alt=""
          />
          <span className="ms-2 fs-6 fw-bold text-primary text-capitalize">
            {totalPoints}
          </span>
        </li>
        <li
          className="d-flex"
          onClick={() => window.open("/plan.php", "_blank")}
        >
          <ArrowUpCircle style={{ width: 22 }} className="text-primary" />
          <span className="text-primary fw-bold">Upgrade Plan</span>
        </li>
        <li
          className="d-flex"
          onClick={() =>
            UserMenuRedirect(`${process.env.PUBLIC_URL}/recruiter/profile`)
          }
        >
          <User style={{ width: 22 }} />
          <span>Edit Profile</span>
        </li>
        <li
          className="d-flex"
          onClick={() =>
            UserMenuRedirect(
              `${process.env.PUBLIC_URL}/recruiter/change_password/`
            )
          }
        >
          <FiEdit style={{ width: 22 }} />
          <span>Change Password</span>
        </li>

        <li className="d-flex" onClick={logout}>
          <LogIn style={{ width: 22 }} />
          <span>Logout</span>
        </li>
      </ul>
    </li>
  );
};

export default UserHeader;
